'use strict';

//***********************************************************************************
//***********************************************************************************
//**** Plugin options
//***********************************************************************************
//***********************************************************************************
class cn_plugin_option_clazz {
    constructor() {
        this.numerotation = true;
        this.zpsos = false;
        this.second_opening_frame = true;
        this.moldings = true;
        this.default_space_label_visibility = 1;
        this.default_space_label = "Esp.";
        this.upper_slabs = true;
        this.vertical_walls = true;

        //*** Marker options: */
        this.default_marker_editable = true;

        //*** remove stairs from space areas ?  */
        this.remove_stairs_from_areas = false;

        /** @type {function} - A custom function to set the readable id. */
        this.make_readable_id = (storey, element) => {return "AC_" + element.build_readable_id(storey)};
    }
}

export const cn_plugin_option = new cn_plugin_option_clazz();
